export default "/images/tag-play.svg?d85438e75600708a8889ad86c6e11b74";